var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHttp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 464 464",
    height: 512,
    viewBox: "0 0 464 464",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m464 64v336c0 17.67-14.33 32-32 32h-400c-17.67 0-32-14.33-32-32v-336c0-17.67 14.33-32 32-32h400c17.67 0 32 14.33 32 32z",
    fill: "#83f8fb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m432.107 82h-350.107c-17.673 0-32 14.327-32 32v286.107c0 32.543-50 34.259-50-.107v-336c0-17.673 14.327-32 32-32h400c34.366 0 32.65 50 .107 50z",
    fill: "#bbfbff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m464 64v64h-464v-64c0-17.67 14.33-32 32-32h400c17.67 0 32 14.33 32 32z",
    fill: "#4d4e59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m432.107 82h-350.107c-17.673 0-32 14.327-32 32v14h-50v-64c0-17.673 14.327-32 32-32h400c34.366 0 32.65 50 .107 50z",
    fill: "#585966"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m32.08 81.57c-.857-8.858 5.642-16.652 14.35-17.49 9.086-.96 17.57 6.222 17.57 15.92 0 8.153-6.21 15.129-14.43 15.92-8.952.862-16.665-5.742-17.49-14.35z",
    fill: "#ff6d7a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m80.08 81.57c-.863-8.918 5.7-16.657 14.35-17.49 9.158-.968 17.57 6.329 17.57 15.92 0 8.212-6.289 15.136-14.43 15.92-8.872.854-16.658-5.663-17.49-14.35z",
    fill: "#ffec8f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m128.08 81.57c-.856-8.852 5.644-16.652 14.35-17.49 9.126-.964 17.57 6.292 17.57 15.92 0 8.25-6.322 15.14-14.43 15.92-8.872.854-16.658-5.663-17.49-14.35z",
    fill: "#cdfdaa"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4d4e59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114 212.155c-8.836 0-16 7.163-16 16v28.845h-14v-28.845c0-8.837-7.164-16-16-16s-16 7.163-16 16v89.689c0 8.837 7.164 16 16 16s16-7.163 16-16v-28.844h14v28.845c0 8.837 7.164 16 16 16s16-7.163 16-16v-89.689c0-8.837-7.164-16.001-16-16.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209 212h-48c-8.836 0-16 7.164-16 16s7.164 16 16 16h8v74c0 8.837 7.164 16 16 16s16-7.163 16-16v-74h8c8.836 0 16-7.164 16-16s-7.164-16-16-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.513 212.155h-18.203c-8.836 0-16 7.163-16 16v89.689c0 8.837 7.164 16 16 16s16-7.163 16-16v-15.654c29.3 0 46.879-21.444 46.879-45.358 0-24.635-20.041-44.677-44.676-44.677zm0 58.035h-2.203v-26.034c20.964-.001 18.009 26.034 2.203 26.034z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303 212h-48c-8.836 0-16 7.164-16 16s7.164 16 16 16h8v74c0 8.837 7.164 16 16 16s16-7.163 16-16v-74h8c8.836 0 16-7.164 16-16s-7.164-16-16-16z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHttp);
export default __webpack_public_path__ + "static/media/http.9a61a8fe0b6885c8d2621ce1e252ae8d.svg";
export { ForwardRef as ReactComponent };